import React, { useState, useEffect, useRef, useContext } from "react";
import { useParams } from "react-router-dom";
import api from "../../api/api";
import Loader from "../../Components/Loader";
import Tab from "../../Components/Annonce/Tab";
import ApercuReservation from "./Apercu";
import Appartement from "../../Components/Sections/Appartements";
import Proprietaire from "../../Components/Sections/Proprietaire";
import Paiement from "../../Components/Sections/Paiement";
import Client from "../../Components/Sections/Client";
import PaiementDetail from './../../Components/Sections/Transaction';
import { MyContext } from "../../Components/Context";

export default function DetailsReservation() {
    const { id } = useParams();
    const [selectedTab, setSelectedTab] = useState("Apercu");
    const [reservationDetails, setReservationDetails] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const { actifItem, setActifItem } = useContext(MyContext);

    const tabItems = ["Apercu", "Appartement", /*"Proprietaire"*/, "Paiements"];
    const apercuRef = useRef(null);
    const appartRef = useRef(null);
    const proprioRef = useRef(null);
    const paiementRef = useRef(null);


    
    useEffect(() => {
        const fetchReservationDetails = async () => {
            try {
                
                const response = await api.get(`/reservations/${id}`);
                setReservationDetails(response.data.reservation);

                setActifItem('Reservations')

            } catch (err) {

                setError("Erreur lors de la récupération des détails de la réservation.");
                console.error(err);
                
            } finally {
                
                setLoading(false);
            }
        };

        fetchReservationDetails();
    }, [id]);


    
    useEffect(() => {
        const options = {
            root: null,
            rootMargin: "0px",
            threshold: 0.5,
        };

        const handleIntersection = (entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    switch (entry.target) {
                        case apercuRef.current:
                            setSelectedTab("Apercu");
                            break;
                        case appartRef.current:
                            setSelectedTab("Appartement");
                            break;
                        case proprioRef.current:
                            setSelectedTab("Proprietaire");
                            break;
                        case paiementRef.current:
                            setSelectedTab("Paiements");
                            break;
                        default:
                            break;
                    }
                }
            });
        };

        const observer = new IntersectionObserver(handleIntersection, options);

        if (apercuRef.current) observer.observe(apercuRef.current);
        if (appartRef.current) observer.observe(appartRef.current);
        if (proprioRef.current) observer.observe(proprioRef.current);
        if (paiementRef.current) observer.observe(paiementRef.current);

        return () => {
            if (apercuRef.current) observer.unobserve(apercuRef.current);
            if (appartRef.current) observer.unobserve(appartRef.current);
            if (proprioRef.current) observer.unobserve(proprioRef.current);
            if (paiementRef.current) observer.unobserve(paiementRef.current);
        };
    }, []);

    const scrollToSection = (section) => {
        switch (section) {
            case "Apercu":
                apercuRef.current.scrollIntoView({ behavior: "smooth" });
                break;
            case "Appartement":
                appartRef.current.scrollIntoView({ behavior: "smooth" });
                break;
            // case "Proprietaire":
            //     proprioRef.current.scrollIntoView({ behavior: "smooth" });
            //     break;
            case "Paiements":
                paiementRef.current.scrollIntoView({ behavior: "smooth" });
                break;
            default:
                break;
        }
    };

    if (loading) return <Loader />;
    if (error) return <div>{error}</div>;

    return (
        <div className="relative grid grid-cols-12 gap-4 p-2">
            
            <div className="grid col-span-12 gap-10 md:col-span-10 md:col-start-2 ">
                {
                    reservationDetails &&
                    <div ref={apercuRef}>
                        <ApercuReservation reservation={reservationDetails.reservation} />
                    </div>
                }
                
                {
                    reservationDetails &&
                    <div ref={appartRef}>
                        <Appartement detail={reservationDetails.reservation.annonce} />
                    </div>
                }

                {
                    reservationDetails.reservation.client &&
                    <div ref={appartRef}>
                        <Client detail={{client : reservationDetails.reservation.client}} />
                        
                    </div>
                }


                {
                    reservationDetails.reservation.annonce.owner &&
                    <div ref={appartRef}>
                        <Proprietaire detail={{owner : {...reservationDetails.reservation.annonce.owner}}} />
                        
                    </div>
                }
               
                {
                    reservationDetails.reservation.paiement &&
                    <div ref={paiementRef}>
                        <PaiementDetail paiement={reservationDetails.reservation.paiement}/>
                    </div>
                }
            </div>
        </div>
    );
}
